import { useCallback } from 'react'
import { useRouter } from 'next/router'


/**
 * Custom hook to update URL query parameter
 *
 * @param {string} key - The query parameter key to sync with
 * @returns {Function} - Returns setter function to update URL. Pass empty string or null to remove param.
 */
export default function useQueryParam(key) {
  const router = useRouter()

  const updateURLParam = useCallback((value) => {
    const { pathname, query } = router
    const newQuery = { ...query }
    if(value === null || value === undefined || value === '') {
      delete newQuery[key]
    } else {
      newQuery[key] = value
    }

    router.push({ pathname, query: newQuery }, undefined, { shallow: true, scroll: false })
  }, [router, key])

  return updateURLParam
}
